import { FunctionalGroup } from "src/app/models/dto/functionalGroup";
import { GraphQLFunctionalGroupOutput } from "../models/output/graphql-functional-group-output";

export function convertGraphqlFunctionalGroupToDto(input: GraphQLFunctionalGroupOutput): FunctionalGroup {
    return {
      uid: input.Uid,
      name: input.Name,
      company: input.Company
    }
  }